module.exports = __webpack_public_path__ + "img/1494396450.de56ee44.jpg";